
function Par(props){
  return <div {...{
    ...props,
    style:{
      margin:30,
    }

    }}>{props.children}</div>
}

export default function WelcomeAbout({setAuthModal}){




  let bottom = (
    <div style={{alignItems:'center'}}>
      <span onClick={() => setAuthModal(true)} class="signin-hover clickable" style={{border:'3px solid darkblue',
        padding:3,
        margin:3,
        borderRadius:10,
        //fontFamily:'Roboto',
        fontSize:32,
        //background:'darkblue',
        //color:'darkblue',
        fontWeight:'bold',
      }}>Join Sciugo</span> and experience fast, secure and traceable scientific research.
    </div>
  );

  bottom = (
    <button
      onClick={() => setAuthModal(true)}
      style={{
        fontSize:28,alignText:'center',
      }} class="btn btn-primary">
      Create a Figure
    </button>
  )



  let formatted = about.split('\n');


  let items = {
    "Figure Creation":[
      "Blots & gels",
      "Microscopy"
    ],
    "Analysis":[],
  }


  return (
    <div style={{
      //border:'3px solid blue',
      height:'100%', overflowY:'scroll'}}>

    

      <div style={{
        //border:'3px solid green',
        padding:'5%',
        fontSize:20,
      }} class="fair-margin">

    <div style={{textAlign:'center'}}>
    </div>

    
        <div style={{
        }}>
          <h2 style={{
            marginBottom:30,
            fontWeight:400,
            fontSize:64,
            textAlign:'center',
            color:'rgb(0, 129, 255)',

          }}>Lab Figures</h2>
          <div style={{
            fontWeight:100,
            //border:'3px solid orange'
            //fontFamily:'Roboto',
            fontSize:28,
            marginLeft:'15%',
              //alignText:'center',
          }}>

            <Par>
              Lab Figures is all about minimalism.
            </Par>
            <Par>
              Do your work and get out.
            </Par>
            <Par>
              We FAIRify everything (Findable, Accessible, Interoperable, Reusable). 
            </Par>
            <Par>
              Work smarter, not harder.
            </Par>
            <Par>
              You cook, we sharpen the pipettes.
            </Par>


            
          </div>
        </div>
      </div>

      <div style={{textAlign:'center'}}>
        {bottom}
      </div>

    </div>
  );
}



let  about = (
  `We're here to streamline research workflows. 

  That's it.

  Planning. 
  Documentation.
  Analysis.
  Presentation
  Sharing.
  `

);

